<template>
  <div class="form-select-box">
    <fieldset>
      <label
        :for="id"
        class="form-label"
        :class="{ 'required-label': isRequire }"
      >{{ labelText }}</label>
      <select
        ref="selectBox"
        :value="selected"
        :disabled="disabled"
        class="form-select form-select-sm"
        @change="$emit('input', $event.target.value)"
      >
        <template v-for="(option, index) in options" :key="index">
          <option
            :value="option.value"
            class="h6"
          >
            {{ option.label }}
          </option>
        </template>
      </select>
    </fieldset>
  </div>
</template>

<script>
export default {
  name: "FormSelectBox",
  props: {
    labelText: {
      type: String,
      default: function () {
        return ""
      },
    },
    id: {
      type: String,
      default: function () {
        return ""
      },
    },
    options: {
      type: Array,
      require: true,
      default: function () {
        return []
      },
    },
    initialValue: {
      type: String,
      default: function () {
        return ""
      },
    },
    isRequire: {
      type: Boolean,
      default: function () {
        return false
      },
    },
    disabled: { type: Boolean, default: false },
  },

  emits: ["input"],

  data: function () {
    return {
      selected: this.initialValue,
    }
  },

  mounted: function () {
    // 初期値を呼び出し元に返す
    this.$emit("input", this.selected)
  },

  methods: {
    /**
     * 値を設定
     */
    setValue(value) {
      this.selected = value
      this.$refs.selectBox.value = value
    },
  },
}
</script>

<style scoped>
:deep(label) {
  display: inline;
}
:deep(.select-box) {
  border: solid 1px#b3b3b3;
  padding: 0.2em;
  border-radius: 5px;
}
.required-label:before {
  content: "*";
  color: red;
}
</style>
